const sectionStyle = {
  maxWidth: "1100px",
  margin: "0 auto",
  padding: "60px 20px"
};

const gridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
  gap: "20px"
};

const cardStyle = {
  border: "1px solid #eee",
  borderRadius: "12px",
  padding: "20px",
  background: "#fff",
  transition: "all 0.2s ease"
};

const hoverEffect = (e, enter = true) => {
  e.currentTarget.style.boxShadow = enter
    ? "0 10px 25px rgba(0,0,0,0.08)"
    : "none";
  e.currentTarget.style.transform = enter
    ? "translateY(-2px)"
    : "translateY(0)";
};

const CloudDevelopment = () => {
  return (
    <div>

      {/* HERO */}
      <div style={{ ...sectionStyle, paddingTop: "80px" }}>
        <h1 style={{ fontSize: "42px", marginBottom: "20px" }}>
          Cloud-Native Development
        </h1>

        <p style={{ fontSize: "20px", color: "#555", maxWidth: "700px" }}>
          Build scalable, production-ready systems using AWS, Java, and Python.
          Focused on serverless architecture and event-driven design.
        </p>

        <div style={{ marginTop: "30px" }}>
          <a href="/contact" style={{
            padding: "14px 28px",
            background: "#007bff",
            color: "#fff",
            borderRadius: "8px",
            textDecoration: "none"
          }}>
            Start a Project
          </a>
        </div>
      </div>


      {/* WHAT I BUILD */}
        {/* WHAT I BUILD */}
        <div style={{ ...sectionStyle, background: "#fafafa" }}>
        <h2 style={{ marginBottom: "30px" }}>What I Build</h2>

        <div style={gridStyle}>
            {[
            "Serverless applications and microservices (AWS Lambda, API Gateway)",
            "Event-driven systems using SNS, SQS, EventBridge, Step Functions",
            "Cloud-native backend platforms (Java Spring Boot, Python)",
            "Enterprise-grade REST APIs and distributed systems",
            "Data processing pipelines and ETL workflows",
            "IoT backend systems and integrations",
            "AI-powered solutions (Bedrock, Textract, Comprehend, Translate)",
            "Modernization of legacy systems into scalable cloud architectures"
            ].map((item, i) => (
            <div
                key={i}
                style={cardStyle}
                onMouseEnter={(e) => hoverEffect(e, true)}
                onMouseLeave={(e) => hoverEffect(e, false)}
            >
                {item}
            </div>
            ))}
        </div>
        </div>


      {/* USE CASES */}
      <div style={sectionStyle}>
        <h2 style={{ marginBottom: "30px" }}>Use Cases</h2>

        <div style={gridStyle}>
            {[
            "Backend systems for web and mobile applications",
            "File processing and document workflows",
            "Automation and event-driven business processes",
            "AI-powered applications and integrations",
            "IoT platforms and real-time data processing",
            "Enterprise system integrations"
            ].map((item, i) => (
            <div
                key={i}
                style={cardStyle}
                onMouseEnter={(e) => hoverEffect(e, true)}
                onMouseLeave={(e) => hoverEffect(e, false)}
            >
                {item}
            </div>
            ))}
        </div>
      </div>


      {/* WHAT YOU GET */}
      <div style={{ ...sectionStyle, background: "#fafafa" }}>
        <h2 style={{ marginBottom: "30px" }}>What You Get</h2>

        <div style={gridStyle}>
          {[
            "Clean, maintainable code",
            "Infrastructure as Code (SAM / CloudFormation)",
            "Production-ready deployment",
            "Documentation and handover"
          ].map((item, i) => (
            <div key={i} style={cardStyle}
                onMouseEnter={(e) => hoverEffect(e, true)}
                onMouseLeave={(e) => hoverEffect(e, false)}
            >
                {item}
            </div>
          ))}
        </div>
      </div>


      {/* TECH */}
        <h2 style={{ marginBottom: "30px" }}>Technologies</h2>

        <div style={gridStyle}>
        {[
            {
            title: "Languages & Backend",
            icon: "💻",
            items: [
                "Java (Spring)",
                "Python",
                "REST APIs, Microservices, Distributed Systems"
            ]
            },
            {
            title: "Cloud & Compute",
            icon: "☁️",
            items: [
                "AWS Lambda",
                "ECS, EKS, Fargate",
                "EC2",
                "Serverless & container-based architectures"
            ]
            },
            {
            title: "Event-Driven & Integration",
            icon: "🔗",
            items: [
                "API Gateway",
                "SNS, SQS",
                "EventBridge",
                "Step Functions",
                "Asynchronous & event-driven systems"
            ]
            },
            {
            title: "Data & Databases",
            icon: "🛢️",
            items: [
                "DynamoDB",
                "RDS, Aurora",
                "PostgreSQL, MySQL, Oracle",
                "MongoDB",
                "ETL pipelines & data processing"
            ]
            },
            {
            title: "Storage",
            icon: "🗄️",
            items: [
                "S3",
                "EBS, EFS",
                "Data lifecycle management"
            ]
            },
            {
            title: "DevOps & Infrastructure",
            icon: "🚀",
            items: [
                "AWS SAM, CloudFormation",
                "Terraform",
                "CI/CD (Jenkins, CodePipeline)",
                "Docker, Kubernetes",
                "Infrastructure as Code"
            ]
            },
            {
            title: "Security",
            icon: "🔐",
            items: [
                "IAM",
                "Cognito",
                "KMS",
                "Secrets Manager",
                "Secure cloud architecture patterns"
            ]
            },
            {
            title: "Monitoring & Reliability",
            icon: "📊",
            items: [
                "CloudWatch",
                "X-Ray",
                "CloudTrail",
                "Logging, tracing, observability"
            ]
            },
            {
            title: "AI & Data Processing",
            icon: "🤖",
            items: [
                "Amazon Bedrock",
                "Textract",
                "Comprehend",
                "Translate",
                "AI-powered document and data workflows"
            ]
            },
            {
            title: "Engineering Practices",
            icon: "🧠",
            items: [
                "Clean Code, SOLID",
                "Design Patterns",
                "TDD, BDD (JUnit, Mockito, Cucumber)",
                "Agile, Scrum, Kanban"
            ]
            }
        ].map((section, i) => (
            <div
            key={i}
            style={cardStyle}
            onMouseEnter={(e) => hoverEffect(e, true)}
            onMouseLeave={(e) => hoverEffect(e, false)}
            >
            <h3>
                {section.icon} {section.title}
            </h3>

            <ul style={{ paddingLeft: "18px", color: "#555", lineHeight: "1.6" }}>
                {section.items.map((item, j) => (
                <li key={j}>{item}</li>
                ))}
            </ul>
            </div>
        ))}
        </div>

        {/* FINAL CTA */}
        <div style={{
        textAlign: "center",
        margin: "100px 0",
        padding: "60px 20px",
        background: "#fafafa"
        }}>
        <h2 style={{
            fontSize: "32px",
            marginBottom: "16px"
        }}>
            Build your cloud-native system
        </h2>

        <p style={{
            color: "#555",
            fontSize: "18px",
            marginBottom: "32px",
            maxWidth: "600px",
            marginLeft: "auto",
            marginRight: "auto",
            lineHeight: "1.6"
        }}>
            Let’s design and implement your solution.
        </p>

        <a href="/contact" style={{
            display: "inline-block",
            padding: "16px 36px",
            background: "#007bff",
            color: "#fff",
            borderRadius: "8px",
            textDecoration: "none",
            fontWeight: "500",
            fontSize: "16px",
            transition: "all 0.2s ease",
            boxShadow: "0 8px 20px rgba(0,0,0,0.1)"
        }}
        onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.boxShadow = "0 12px 30px rgba(0,0,0,0.15)";
        }}
        onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.1)";
        }}
        >
            Start Now
        </a>
        </div>      

    </div>
  );
};

export default CloudDevelopment;